/**
 * Created by calhosh on 5/2/2023
 */
import $ from 'jquery';
import {bodyFreeTextBodyTypes, clientSideEventNames, formBodyType, multiOptionBodyTypes} from '../../util/uiconstants';
import Utility from '../../util/utilityfunctions';
import _ from 'lodash';

export function processBodyResponses(
	formBodyDisplayData,
	formBodyData,
	formData,
	selectedBodyOptions,
	bodyTypeId,
	bodySelectedOption,
	concurrencyToken,
	isAresView
) {
	updateBodyDisplayAndConcurrencyToken(
		formBodyData,
		formBodyDisplayData,
		bodySelectedOption,
		concurrencyToken,
		selectedBodyOptions,
		bodyTypeId
	);

	if (formData) {
		if (
			formBodyDisplayData.bodyIsDisplayDetails &&
			formBodyDisplayData.bodyIsDisplayDetails.headerSectionDisplayDetails
		) {
			let headers = formData.headers;
			let shownHeaders = formBodyDisplayData.bodyIsDisplayDetails.headerSectionDisplayDetails;
			if (headers && headers.length > 0 && shownHeaders && shownHeaders.length > 0) {
				if (isAresView) {
					/*check if shownHeaders is in the current document or we clicked on a different tab.*/
					const firstShownHeader = shownHeaders[0].formHeaderId;
					let inThisDoc = headers.filter((h) => {
						return h.id === firstShownHeader;
					});
					if (inThisDoc && inThisDoc.length > 0) {
						showOrHideHeadersAndSections(headers, shownHeaders);
					}
				} else {
					showOrHideHeadersAndSections(headers, shownHeaders);
				}
			}
		}
	}
	if (
		formBodyDisplayData.bodyTypeId !== formBodyType.TextResponse &&
		formBodyDisplayData.bodyTypeId !== formBodyType.InlineRichText
	) {
		window.dispatchEvent(
			new CustomEvent(clientSideEventNames.getValidations, {
				detail: {documentTypeId: formData?.documentTypeId, source: 'responseChange'}
			})
		);
		if ($('.greyOutArea').length > 0) {
			$('.greyOutArea').removeClass('greyOutArea');
		}
	}

	return {formBodyData: formBodyData, formData: formData};
}

function updateBodyDisplayAndConcurrencyToken(
	formBodyData,
	formBodyDisplayData,
	bodySelectedOption,
	concurrencyToken,
	selectedBodyOptions,
	bodyTypeId
) {
	let thisBody = undefined;
	formBodyData &&
		formBodyData.length > 0 &&
		formBodyData.map((data) => {
			if (
				formBodyDisplayData.bodyIsDisplayDetails &&
				formBodyDisplayData.bodyIsDisplayDetails.bodyUpdateIsDisplayReadModel &&
				formBodyDisplayData.bodyIsDisplayDetails.bodyUpdateIsDisplayReadModel.length > 0
			) {
				formBodyDisplayData.bodyIsDisplayDetails.bodyUpdateIsDisplayReadModel.map((bdd) => {
					if (bdd.formBodyId === data.id) {
						data.isDisplayed = bdd.isDisplayed;
						data.concurrencyToken = bdd.concurrencyToken;

						let existingPayload = Utility.getStoredPayload(data.id);
						if (existingPayload) {
							existingPayload.concurrencyToken = data.concurrencyToken;
							existingPayload.isDisplayed = data.isDisplayed;
							Utility.setStoredPayload(data.id, existingPayload);
						}
					}
				});
			}
			if (data.id === formBodyDisplayData.id) {
				thisBody = data;
			}
		});

	if (thisBody) {
		if (bodyFreeTextBodyTypes.find((bt) => bt === formBodyDisplayData.bodyTypeId)) {
			thisBody.bodyFreeText = formBodyDisplayData.bodyFreeText;
			thisBody.concurrencyToken = concurrencyToken;
			thisBody.bodyTypeId = formBodyDisplayData.bodyTypeId;
		} else if (
			multiOptionBodyTypes.find((bodyType) => bodyType === formBodyDisplayData.bodyTypeId) &&
			thisBody.optionsAndResponses &&
			thisBody.optionsAndResponses.length > 0
		) {
			thisBody.optionsAndResponses.map((option) => {
				if (
					_.findIndex(selectedBodyOptions, function(obj) {
						return obj === option.bodyOptionId;
					}) > -1
				) {
					option.bodySelectedOptionId = option.bodyOptionId;
				} else {
					option.bodySelectedOptionId = 0;
				}
			});
		} else if (bodyTypeId === formBodyType.PaceConclusion) {
			thisBody.bodyRelatedObjects[0].paceTypeId = bodySelectedOption[0].paceTypeId;
		}
	}
}

function showOrHideHeadersAndSections(headers, shownHeaders) {
	headers.map((h) => {
		let shownHeader = shownHeaders.find((sh) => {
			return sh.formHeaderId === h.id;
		});
		if (shownHeader) {
			if (h.sections && h.sections.length > 0) {
				h.sections
					.sort((a, b) => a.knowledgeDisplayOrder - b.knowledgeDisplayOrder)
					.map((s) => {
						if (!shownHeader) {
							s.isDisplayed = false;
						} else {
							let thisSection = shownHeader.formSectionIds.find((fsid) => {
								return fsid === s.id;
							});
							if (thisSection) {
								s.isDisplayed = true;
							} else {
								s.isDisplayed = false;
							}
						}
					});
			}
		} else {
			/*header not found in list of displayed headers. hide all sections*/
			if (h.sections && h.sections.length > 0) {
				h.sections.map((s) => {
					s.isDisplayed = false;
				});
			}
		}
	});
}
